import { Injectable,Injector } from '@angular/core';
import {HttpInterceptor} from '@angular/common/http'
import * as CryptoJS from 'crypto-js';
import {en} from '../environments/environment.tok'
import {en as enk} from '../environments/environments.k'

@Injectable({
  providedIn: 'root'
})
export class TokenInterCepterService {

  constructor(private injector:Injector) { }

   intercept(req:any,next:any){
    let tokenizedReq=req.clone({
      setHeaders:{
        1000:`bearer ${sessionStorage.getItem('1000')}`,
        1001:`${sessionStorage.getItem('1001')}`,
        1002:`${this.encryptUsingAES256(en.token)}`,
        1003:`${en.session}`,
        1005:`${sessionStorage.getItem('1005')}`,
        'X-XSS-Protection': '1; mode=block'  
      }
    })
    console.log(req.url.split('%')[0],'--',sessionStorage.getItem('1000'),'--', tokenizedReq.headers.get("1000"));
    
    // console.log(tokenizedReq)
    return next.handle(tokenizedReq)
  }
   encryptUsingAES256(request:any) {
    let _key = CryptoJS.enc.Utf8.parse(enk.jump);
    let _iv = CryptoJS.enc.Utf8.parse(enk.jump);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }







}
